var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      staticClass: "alerts-context-menu",
      attrs: {
        bottom: "",
        left: "",
        "nudge-bottom": "48",
        "nudge-right": "18",
        "content-class": "navigation-context-menu",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(
                  _vm._b(
                    {
                      class: [
                        _setup.iconAlerts,
                        "main-icon",
                        { "exist-unread-alerts": _setup.userHasAlerts },
                      ],
                      on: { click: _setup.onClick },
                    },
                    "span",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [
      _setup.ListStatus.LOADING === _setup.status
        ? _c(_setup.SpinnerLayerComponent, {
            staticClass: "spinner-layer-container",
          })
        : _c(_setup.AlertsListComponent),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }